function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* eslint-disable react/jsx-props-no-spreading */

/* eslint-disable react/require-default-props */
import React from 'react';
import { string, node, bool, func } from 'prop-types';
import cn from 'classnames';
import { ButtonBase, sizes, alignOptions } from './styles/ButtonStyles';
import Anchor from './styles/AnchorStyles';
import { colors } from '../colorSwatches';
/**
 * A Button component containing functionality, mark-up, and styles.
 * @function
 * @returns {JSX.Element} - Rendered component (define any specifics if applicable)
 */

function Button(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      theme = _ref.theme,
      color = _ref.color,
      bgColor = _ref.bgColor,
      bgColorHover = _ref.bgColorHover,
      borderHover = _ref.borderHover,
      size = _ref.size,
      height = _ref.height,
      variant = _ref.variant,
      children = _ref.children,
      _ref$expand = _ref.expand,
      expand = _ref$expand === void 0 ? true : _ref$expand,
      _ref$anchor = _ref.anchor,
      anchor = _ref$anchor === void 0 ? false : _ref$anchor,
      href = _ref.href,
      target = _ref.target,
      setWidth = _ref.setWidth,
      alignment = _ref.alignment,
      alignContent = _ref.alignContent,
      _ref$dataAnalyticsId = _ref.dataAnalyticsId,
      dataAnalyticsId = _ref$dataAnalyticsId === void 0 ? null : _ref$dataAnalyticsId,
      _ref$dataAnalyticsLab = _ref.dataAnalyticsLabel,
      dataAnalyticsLabel = _ref$dataAnalyticsLab === void 0 ? null : _ref$dataAnalyticsLab,
      buttonValue = _ref.buttonValue,
      buttonName = _ref.buttonName,
      disabled = _ref.disabled,
      event = _ref.event,
      restProps = _objectWithoutProperties(_ref, ["className", "theme", "color", "bgColor", "bgColorHover", "borderHover", "size", "height", "variant", "children", "expand", "anchor", "href", "target", "setWidth", "alignment", "alignContent", "dataAnalyticsId", "dataAnalyticsLabel", "buttonValue", "buttonName", "disabled", "event"]);

  var themeConst = theme;
  var sizeConst = size;
  var alignmentConst = alignment;

  var switchTheme = function switchTheme() {
    switch (themeConst) {
      case 'plum':
        color = colors.white;
        bgColor = colors.plum;
        bgColorHover = colors.plumHover;
        break;

      case 'aqua':
        color = colors.white;
        bgColor = colors.aqua;
        bgColorHover = colors.aquaHover;
        break;

      case 'ocean':
        color = colors.white;
        bgColor = colors.ocean;
        bgColorHover = colors.oceanHover;
        break;

      case 'cobalt':
        color = colors.white;
        bgColor = colors.cobalt;
        bgColorHover = colors.cobaltHover;
        break;

      case 'black':
        color = colors.white;
        bgColor = colors.grayBlack;
        bgColorHover = colors.black;
        break;

      case 'white':
        color = colors.grayMid;
        bgColor = colors.white;
        bgColorHover = colors.grayLight;
        break;

      case 'transparent':
        color = colors.white;
        bgColor = 'hsla(0, 0%, 100%, 0)';
        bgColorHover = 'hsla(0, 0%, 100%, 0)';
        borderHover = 'hsla(0, 0%, 100%, 0)';
        break;

      default:
        return color = colors.white, bgColor = colors.plum, bgColorHover = colors.plumHover;
    }
  };

  var switchSize = function switchSize() {
    switch (sizeConst) {
      case 'skinny':
        height = sizes.skinny;
        break;

      case 'small':
        height = sizes.small;
        break;

      case 'medium':
        height = sizes.medium;
        break;

      default:
        return height = sizes.medium;
    }
  };

  var switchAlignment = function switchAlignment() {
    switch (alignmentConst) {
      case 'align-left':
        alignContent = alignOptions.alignLeft;
        break;

      case 'center':
        alignContent = alignOptions.alignCenter;
        break;

      case 'align-right':
        alignContent = alignOptions.alignRight;
        break;

      default:
        return alignContent = alignOptions.alignCenter;
    }
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, anchor === false ? /*#__PURE__*/React.createElement(ButtonBase, _extends({
    theme: switchTheme(),
    color: color,
    bgColor: bgColor,
    bgColorHover: bgColorHover,
    borderHover: borderHover,
    className: cn(className),
    "data-analytics-id": dataAnalyticsId,
    "data-test-id": "scl-button",
    "data-analytics-label": dataAnalyticsLabel,
    type: "button",
    value: buttonValue,
    name: buttonName,
    onClick: event,
    style: {
      width: expand === false && setWidth
    },
    size: switchSize(),
    height: height,
    alignment: switchAlignment(),
    alignContent: alignContent,
    disabled: disabled
  }, restProps), children) : /*#__PURE__*/React.createElement(Anchor, {
    className: "anchor",
    style: {
      width: expand === false && setWidth
    },
    href: href,
    target: target,
    "data-test-id": "anchor",
    onClick: event
  }, /*#__PURE__*/React.createElement(ButtonBase, _extends({
    theme: switchTheme(),
    color: color,
    bgColor: bgColor,
    bgColorHover: bgColorHover,
    borderHover: borderHover,
    className: cn(className),
    "data-analytics-id": dataAnalyticsId,
    "data-test-id": "scl-button",
    "data-analytics-label": dataAnalyticsLabel,
    type: "button",
    value: buttonValue,
    name: buttonName,
    onClick: event,
    size: switchSize(),
    height: height,
    alignment: switchAlignment(),
    alignContent: alignContent,
    disabled: disabled
  }, restProps), children)));
}

Button.propTypes = {
  /**
   * Define additional classNames.
   */
  className: string,

  /**
   * Define theme color.
   */
  theme: string,

  /**
   * Font theme color and the border.
   */
  color: string,

  /**
   * Background theme color.
   */
  bgColor: string,

  /**
   * Background hover theme color.
   */
  bgColorHover: string,

  /**
   * Border hover theme color.
   */
  borderHover: string,

  /**
   * Button text or content.
   * Only inline elements are valid children for a button.
   */
  children: node.isRequired,

  /**
   * Define button variant.
   */
  variant: string,

  /**
   * Define button size - based on button's padding.
   */
  size: string,

  /**
   * Define content alignment.
   * flex-start, center, flex-end
   */
  alignment: string,

  /**
   * Define content alignment.
   */
  alignContent: string,

  /**
   * Define data analytics label.
   */
  dataAnalyticsLabel: string,

  /**
   * Define data analytics id.
   */
  dataAnalyticsId: string,

  /**
   * Define button value.
   */
  buttonValue: string,

  /**
   * Define button name.
   */
  buttonName: string,

  /**
   * Define if button width is 100%.
   */
  expand: bool,

  /**
   * Set a button width (expand must be set to false).
   */
  setWidth: string,

  /**
   * Define if button requires a link
   */
  anchor: bool,

  /**
   * Define a href if anchor is true.
   */
  href: string,

  /**
   * Define a target if anchor is true.
   */
  target: string,

  /**
   * Define if disabled.
   */
  disabled: bool,

  /**
   * Define a click event for button
   */
  event: func
};
export default Button;